// extracted by mini-css-extract-plugin
export default {"section":"_b5062060","content":"_75844100"};